import { useEffect, useMemo } from 'react'
import { FileRow } from 'components/ui/FileRow'
import { Spinner } from 'components/ui/Spinner'

export type ComposerItem = {
  id: string
  name: string
  size: number
  file: File
  loading?: boolean
  uploading?: boolean
}

type ComposerAttachmentsProps = {
  items: ComposerItem[]
  onRemove: (id: string) => void
  disabled?: boolean
}

export const ComposerAttachments = ({ items, onRemove, disabled }: ComposerAttachmentsProps) => {
  // Object URLs for image previews, recreated only when the set of files changes.
  const previews = useMemo(
    () => items.map((item) => (item.file.type.startsWith('image/') ? URL.createObjectURL(item.file) : undefined)),
    [items],
  )

  useEffect(() => {
    return () => {
      previews.forEach((url) => url && URL.revokeObjectURL(url))
    }
  }, [previews])

  if (items.length === 0) return null

  return (
    <div className="tw-flex tw-flex-col tw-gap-1.5 tw-px-1 tw-pt-1 tw-pb-1.5">
      {items.map((item, index) => (
        <div key={item.id} className="animate-fade-slide-in tw-relative">
          <FileRow
            fileName={item.name}
            fileSize={item.size}
            previewUrl={previews[index]}
            onDelete={disabled || item.uploading ? undefined : () => onRemove(item.id)}
          />
          {item.loading && (
            <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-bg-[var(--surface-glass-heavy)]">
              <Spinner color="var(--brand-text)" className="tw-h-4 tw-w-4" />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
